<template>
  <v-container >
    <entity-properties-row :label="$t('corporation.name')"
                           :property="corporation.name"/>

    <entity-properties-row :label="$t('corporation.allowCsvExportTableHeader')"
                           :property="corporation.allowCsvExport | yesNo"/>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';

export default {
  name: 'CorporationPropertiesView',
  components: { EntityPropertiesRow },
  props:{
    corporation: {
      required:true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
